// libs
import React from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Svg12 as CloseIcon } from '@swiggy-private/dls-web-icons/dist/web/generic/close';
// styles
import styles from './Chip.module.scss';
// helpers
import { getLabelProps } from './helper';
const Chip = (props) => {
    const { label, onChipClick, onActionButtonClick, labelColor, labelVariant, containerClass, ActionIcon, disabled, showActionButton: canShowActionButton, } = props;
    const labelProps = getLabelProps(labelColor, labelVariant);
    const showActionButton = canShowActionButton ||
        (onActionButtonClick && typeof onActionButtonClick === 'function');
    const chipContainerClass = cx(styles.container, containerClass);
    // Event handlers
    const handleClick = (e) => {
        if (disabled)
            return null;
        e.stopPropagation();
        onChipClick && onChipClick();
    };
    const handleActionButtonClick = (e) => {
        onActionButtonClick && e.stopPropagation();
        onActionButtonClick && onActionButtonClick();
    };
    //  Render functions
    const renderActions = () => {
        if (disabled || !showActionButton) {
            return null;
        }
        const Icon = ActionIcon !== null && ActionIcon !== void 0 ? ActionIcon : CloseIcon;
        return (React.createElement("div", { className: styles.action }, showActionButton && (React.createElement(GenericIcon, { fillColor: labelProps.color, Icon: Icon, onClick: handleActionButtonClick }))));
    };
    return (React.createElement("div", { onClick: handleClick, className: chipContainerClass },
        React.createElement(Text, Object.assign({}, labelProps, { className: styles.label }), label),
        renderActions()));
};
export default Chip;
